:host {
  display: block;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
}

.code-block {
  width: 100%;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  border-radius: var(--dimension-radius-050);
  background: var(--color-background-strong-neutral);
  color: var(--color-foreground-faint-neutral);
  box-sizing: border-box;
}

.code-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--dimension-space-100);
  min-height: var(--dimension-size-400);
  padding: var(--dimension-space-050) var(--dimension-space-100);
  background: var(--color-background-strong-neutral);
  box-sizing: border-box;
}

pre {
  margin: 0;
  padding: var(--dimension-space-150);
  overflow: auto;
  font-family: var(
    --typography-font-family-code,
    'Fira Code', ui-monospace, 'SFMono-Regular', 'Cascadia Code', 'Roboto Mono',
    Menlo, Monaco, Consolas, 'Liberation Mono', monospace
  );
  font-size: var(--typography-fontsize-sm);
  font-variant-ligatures: var(--ds-code-font-variant-ligatures, normal);
  font-weight: var(--typography-weight-regular);
  line-height: var(--typography-lineheight-sm);
  letter-spacing: var(--typography-letterspacing-none);
  tab-size: 2;
  -webkit-user-select: text;
  user-select: text;
}

code {
  font: inherit;
  white-space: pre;
}
